import { Flex, Accordion, List, ListItemOption } from "@theorgchartdev/storybook";
import { ComponentProps, Fragment } from "react";
import { enumObjectTypes } from "@coreapp/constants";

interface AccordionListProps extends ComponentProps<typeof Accordion> {}

function AccordionList(props: AccordionListProps) {
  return (
    <Flex
      direction={"column"}
      gap={"6px"}
      alignItems="flex-start"
      justifyContent="center"
      width={"100%"}
    >
      <Accordion
        containerClass="oc-fill-width"
        labelProps={{
          customStyle: {
            paddingLeft: 0,
            fontWeight: 500
          }
        }}
        {...props}
      />
    </Flex>
  );
}

type AccordionSectionsProps = {
  sections: {
    name: string;
    data: any[];
    objType: (typeof enumObjectTypes)[keyof typeof enumObjectTypes];
    options: ListItemOption[];
    dataTestId?: string;
  }[];
};

export function AccordionSections({ sections }: AccordionSectionsProps) {
  return (
    <>
      {sections.map(section => (
        <Fragment key={section.objType}>
          {section?.data?.length > 0 ? (
            <AccordionList
              name={section.name}
              beforeContent={
                <Flex direction={"column"} gap={"4px"} margin={"-8px 0 0 0"}>
                  <List
                    enableVirtualization={false}
                    options={section.options}
                    optionSize={"small"}
                    listWidth={"fill"}
                    showCheck={false}
                  />
                </Flex>
              }
              dataTestId={section.dataTestId}
            />
          ) : null}
        </Fragment>
      ))}
    </>
  );
}

export default AccordionList;
